// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"b8","header":"b9","message":"b-","copyMessage":"b_","button":"ca"};